export default "__VITE_ASSET__CQL8jv8o__"